import { ReactElement } from "react";
import { Modal, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { DELETE_CLUB_REQUEST, FETCH_ALL_USERS_REQUEST } from "../../redux/constants";
import { getAuthState } from "../../redux/selectors";

type Props = {
  visible: boolean;
  onClose: () => void;
  club: any;
};

export function DeleteClubModal({
  visible,
  onClose,
  club,
}: Props): ReactElement {
  const dispatch = useDispatch();
  const { currentUser } = useSelector(getAuthState);

  const onFinish = () => {
    dispatch({
      type: DELETE_CLUB_REQUEST,
      payload: { key: club.key, currentUser },
    });
    message.success("Club has been deleted successful!");
    dispatch({ type: FETCH_ALL_USERS_REQUEST });
    onClose();
  };

  return (
    <Modal
      title="Confirm"
      centered
      visible={visible}
      onOk={onFinish}
      onCancel={onClose}
    >
      <p>Are you sure to delete {club.name}</p>
    </Modal>
  );
}
